var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-error",attrs:{"id":"search-error"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"search-list"},[(_vm.labels)?_c('h5',[_vm._v(_vm._s(_vm.labels['searchpageError']))]):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }